<template>
  <div id="healthAssessment">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">mdi-close</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Participants"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="getFeedbackData()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container style="width: 100%; max-width: 1060px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <p class="text-center display-1 primary--text">Core assessment rating</p>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Number Surveys Completed For Each Consultant</v-toolbar-title
              ><a
                class="reset"
                @click="reset_filters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="consultants-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Survey Template Count</v-toolbar-title
              ><a
                class="reset"
                @click="reset_filters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="surveys-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Number of Surveys</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div
                id="survey-count"
                class="dc-chart display-4 font-weight-regular"
              ></div>
              <div
                id="survey-count-filtered"
                class="dc-chart display-2 font-weight-regular"
              >{{ totalSurveyCount }}</div>
            </v-row>
          </div>
        </div>

        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Gender</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="gender-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>

        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Number of Surveys %</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div
                id="survey-percentage"
                class="display-4 font-weight-regular"
              ></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Booking Experience</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="booking-experience-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Start On Time</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="start-on-time-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Enough Time</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="enough-time-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Lifestyle Changes</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="lifestyle-changes-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Professionalism</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="professionalism-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Rate Health Assessment</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="rate-health-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Recommend</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="recommend-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-3">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Future Participation</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="future-participation-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Feedback, Useful Principles & Techniques</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center" style="margin: 0 15px">
              <table
                id="feedback-table"
                class="table table-hover dc-data-table"
              >
                <thead>
                  <tr class="header">
                    <th>Feedback</th>
                    <th style="width: 120px">Consultant</th>
                    <th style="width: 120px">Company</th>
                  </tr>
                </thead>
              </table>
            </v-row>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import HealthAssessment from "../classes/HealthAssessment";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      parametersDialog: false,
      consultantsChart: null,
      genderChart: null,
      surveyCount: null,
      totalSurveyCount: null,
      surveyCountPercentage: null,
      bookingExperienceChart: null,
      startOnTimeChart: null,
      enoughTimeChart: null,
      lifestyleChangesChart: null,
      professionalismChart: null,
      rateHealthChart: null,
      recommendChart: null,
      futureParticipationChart: null,
      pieLabel: {},
      pieColor: {},
      uniqueCompanies: [],
      uniqueParticipants: [],
      from: false,
      fromDate: null,
      to: false,
      toDate: null,
      participants: "All",
      service: "All",
      participantsLoaded: false,
      companies: "All",
    };
  },
  async mounted() {
    this.loading = true;
    this.pieLabel = {
      0: "F",
      1: "M",
      average: "Avg",
      excellent: "Excel",
      good: "Good",
      poor: "Poor",
      verygood: "V.Good",
      yes: "Yes",
      no: "No",
      dontknow: "Dont Know",
      null: "Ignore",
    };
    this.pieColor = {
      excellent: "#B2D732",
      verygood: "#66B032",
      good: "#375F1B",
      average: "#e6550d",
      poor: "#c62828",
      no: "#c62828",
      yes: "#B2D732",
      dontknow: "#e6550d",
      null: "#e376c2",
    };

    this.fromDate = moment().subtract(6, "months").format("YYYY-MM-DD");
    this.toDate = moment().format("YYYY-MM-DD");

    let healthAssessment = new HealthAssessment(null);
    await healthAssessment.getGraphData();

    this.uniqueCompanies = await healthAssessment.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");

    this.uniqueParticipants = await healthAssessment.getUniqueConsultants();
    this.uniqueParticipants.unshift("All");

    this.getFeedbackData();

    this.loading = false;
  },
  methods: {
    async getFeedbackData() {
      const that = this;
      this.parametersDialog = false;
      this.loading = true;

      // Filter Data according to dialog selection criteria
      let filter = null;
      let query = [];

      if (this.companies && this.companies !== "All") {
        query.push({ companyName: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          createdAt: {
            between: [from, to],
          },
        });
      }

      if (this.service && this.service !== "All") {
        query.push({ service: { contains: this.service } });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then((user) => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach((q) => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach((q) => {
            Object.assign(filter, q);
          });
        }
      }

      // Get Health Assessment Feedback Data
      let healthAssessment = new HealthAssessment(filter);
      await healthAssessment.getGraphData();
      const data = healthAssessment.getFilteredData();
      const rawdata = healthAssessment.getRawData();

      var cf = crossfilter(data);

      // Consultant Bar Chart
      that.renderConsultantsChart(cf);

      // Surveys Bar Chart
      that.renderSurveysChart(cf);

      // Gender Pie Chart
      that.renderGenderChart(cf);

      // Survey Count & Survey Percentage
      that.renderSurveyNumberDisplay(cf, data, rawdata);

      // Booking Experience Chart
      that.renderBookingExperienceChart(cf);

      // Enough Time Chart
      that.renderEnoughTimeChart(cf);

      // Lifestyle Changes Chart
      that.renderLifestyleChangesChart(cf);

      // Start On Time Chart
      that.renderStartOnTimeChart(cf);

      // Professionalism Chart
      that.renderProfessionalismChart(cf);

      // Rate Health Assessment Chart
      that.renderHealthAssessmentChart(cf);

      // Recommendation Chart
      that.renderRecommendationChart(cf);

      // Future Participation Chart
      that.renderFutureParticipationChart(cf);

      // Feedback Table
      this.renderFeedbackTable(cf);

      dc.renderAll();
      this.loading = false;
    },
    renderConsultantsChart(cf) {
      const that = this;
      this.consultantsChart = dc.barChart("#consultants-chart");

      var consultantDimension = cf.dimension(function (d) {
        return d.consultant || "Undefined";
      });
      var consultantGrouping = consultantDimension.group();
      that.consultantsChart
        .width(768)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 105, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("Health Assessments")
        .dimension(consultantDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(consultantGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderSurveysChart(cf) {
      const that = this;
      this.surveysChart = dc.barChart("#surveys-chart");

      var surveyDimension = cf.dimension(function (d) {
        return d.surveyTemplate || "Undefined";
      });
      var surveyGrouping = surveyDimension.group();
      that.surveysChart
        .width(768)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 105, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("Health Assessments")
        .dimension(surveyDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(surveyGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderGenderChart(cf) {
      const that = this;

      this.genderChart = dc.pieChart("#gender-chart");

      var genderDimension = cf.dimension(function (d) {
        return d.gender;
      });
      var genderGrouping = genderDimension.group();

      this.genderChart
        .width(150)
        .height(150)
        .dimension(genderDimension)
        .group(genderGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        ;
    },
    renderSurveyNumberDisplay(cf, data, filtered) {
      const that = this;
      this.surveyCount = dc.numberDisplay("#survey-count");
      // this.surveyCountFiltered = dc.numberDisplay("#survey-count-filtered");
      this.surveyCountPercentage = dc.numberDisplay("#survey-percentage");
      this.totalSurveyCount = `/${filtered.length}`;

      // Survey Count
      var surveyCount = data.length;
      var all = cf.groupAll();
      var feedback_group = all.reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
          ++p.count;
          p.percentage = p.count / surveyCount;
          return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
          --p.count;
          p.percentage = p.count / surveyCount;
          return p;
        },
        /* initialize p */
        function () {
          return {
            count: 0,
            percentage: 0,
          };
        }
      );

      that.surveyCount
        .group(feedback_group).valueAccessor(function (p) {
          return p.count;
        })
        .formatNumber(d3.format("0"));

      // Survey Percentage
      that.surveyCountPercentage
        .group(feedback_group)
        .valueAccessor(function (p) {
          return p.percentage;
        })
        .formatNumber(d3.format(".0%"));
    },
    renderBookingExperienceChart(cf) {
      const that = this;
      this.bookingExperienceChart = dc.pieChart("#booking-experience-chart");
      var bookingExpDimension = cf.dimension(function (d) {
        return d.bookingExperience || "null";
      });
      var bookingExpGrouping = bookingExpDimension.group();

      this.bookingExperienceChart
        .width(150)
        .height(150)
        .dimension(bookingExpDimension)
        .group(bookingExpGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderStartOnTimeChart(cf) {
      const that = this;
      this.startOnTimeChart = dc.pieChart("#start-on-time-chart");
      var startOnTimeDimension = cf.dimension(function (d) {
        return d.onTime || "yes";
      });
      var startOnTimeGrouping = startOnTimeDimension.group();

      this.startOnTimeChart
        .width(150)
        .height(150)
        .dimension(startOnTimeDimension)
        .group(startOnTimeGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderEnoughTimeChart(cf) {
      const that = this;
      this.enoughTimeChart = dc.pieChart("#enough-time-chart");
      var enoughTimeDimension = cf.dimension(function (d) {
        return d.discussResults || "null";
      });
      var enoughTimeGrouping = enoughTimeDimension.group();

      that.enoughTimeChart
        .width(150)
        .height(150)
        .dimension(enoughTimeDimension)
        .group(enoughTimeGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderLifestyleChangesChart(cf) {
      const that = this;
      this.lifestyleChangesChart = dc.pieChart("#lifestyle-changes-chart");
      var lifestyleChangesDimension = cf.dimension(function (d) {
        return d.lifestyleChange || "null";
      });
      var lifestyleChangesGrouping = lifestyleChangesDimension.group();

      that.lifestyleChangesChart
        .width(150)
        .height(150)
        .dimension(lifestyleChangesDimension)
        .group(lifestyleChangesGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderProfessionalismChart(cf) {
      const that = this;
      this.professionalismChart = dc.pieChart("#professionalism-chart");
      var professionalismDimension = cf.dimension(function (d) {
        return d.professionalism || "null";
      });
      var professionalismGrouping = professionalismDimension.group();

      this.professionalismChart
        .width(150)
        .height(150)
        .dimension(professionalismDimension)
        .group(professionalismGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderHealthAssessmentChart(cf) {
      const that = this;
      this.rateHealthChart = dc.pieChart("#rate-health-chart");
      var rateHealthDimension = cf.dimension(function (d) {
        return d.experience || "null";
      });
      var rateHealthGrouping = rateHealthDimension.group();

      this.rateHealthChart
        .width(150)
        .height(150)
        .dimension(rateHealthDimension)
        .group(rateHealthGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderRecommendationChart(cf) {
      const that = this;
      this.recommendChart = dc.pieChart("#recommend-chart");
      var recommendDimension = cf.dimension(function (d) {
        return d.recommend || "null";
      });
      var recommendGrouping = recommendDimension.group();

      this.recommendChart
        .width(150)
        .height(150)
        .dimension(recommendDimension)
        .group(recommendGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderFutureParticipationChart(cf) {
      const that = this;
      this.futureParticipationChart = dc.pieChart(
        "#future-participation-chart"
      );
      var futureParticipationDimension = cf.dimension(function (d) {
        return d.recommend || "null";
      });
      var futureParticipationGrouping = futureParticipationDimension.group();

      this.futureParticipationChart
        .width(150)
        .height(150)
        .dimension(futureParticipationDimension)
        .group(futureParticipationGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderFeedbackTable(cf) {
      this.feedbackTable = dc.dataTable("#feedback-table");
      var feedbackDimension = cf.dimension(function (d) {
        return d.comment;
      });

      this.feedbackTable
        .dimension(feedbackDimension)
        // .columns(["comment", "consultant"])
        .columns([
          function (d) {
            return (
              '<a href="http://core.healthyperformance.co.uk/admin/test/' +
              d.testId +
              '" target="_blank">' +
              d.comment +
              "</a>"
            );
          },
          function (d) {
            return d.consultant;
          },
          function (d) {
            return d.companyName;
          }
        ])
        .size(100)
        .sortBy(function (d) {
          return d.comment;
        })
        .order(d3.ascending)
        .on("pretransition", function (table) {
          var body = table.selectAll("tbody");
          body.selectAll("tr").style("display", function (d) {
            if (d.comment === null) {
              return "none";
            }
          });
        });
    },
    adjustBarChartLabels(chart) {
      chart
        .svg()
        .selectAll(".axis.x text")
        .on("click", function (d) {
          chart.filter(d);
          dc.redrawAll();
          scrollTo(d);
        })
        .style("text-anchor", "end")
        .attr("dx", function (d) {
          return "-0.6em";
        })
        .attr("transform", function (d) {
          return "rotate(-90, -4, 9) ";
        });
    },
    reset_filters() {
      this.consultantsChart.filterAll();
      this.genderChart.filterAll();
      this.bookingExperienceChart.filterAll();
      this.startOnTimeChart.filterAll();
      this.enoughTimeChart.filterAll();
      this.lifestyleChangesChart.filterAll();
      this.professionalismChart.filterAll();
      this.rateHealthChart.filterAll();
      this.recommendChart.filterAll();
      this.futureParticipationChart.filterAll();
      dc.redrawAll();
    },
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
<style>
.dc-table-section {
  display: none !important;
}
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
</style>